export default {
  common: {
    back: 'กลับ',
    loading: 'กำลังโหลด…',
    empty: 'ไม่มีข้อมูล',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    search: 'ค้นหา',
    submit: 'ส่ง',
    retry: 'ลองใหม่',
    downloading: 'กำลังดาวน์โหลด…',
    downloadDone: 'ดาวน์โหลดสำเร็จ',
    browserTipLine1: 'กรุณาแตะมุมขวาบน',
    browserTipLine2: 'แล้วเลือกเปิดในเบราว์เซอร์เริ่มต้น',
    workType: {
      video: 'วิดีโอ',
      image: 'รูปภาพ',
      audio: 'เพลง',
      pdf: 'แฟ้มผลงาน PDF',
      game: 'เกม',
      bigImage: 'แฟ้มผลงาน',
      linkCard: 'แฟ้มผลงานเว็บ',
      openMaic: 'คำอธิบายภาพ',
      artBook: 'นิทานภาพ',
      model3d: 'โมเดล 3D',
    },
    share: {
      titleVideo: 'เพิ่งเจอวิดีโอที่น่าสนใจมาก แชร์ให้ดูเลย!',
      titleImage: 'เจอรูปภาพสร้างสรรค์มาก แชร์ให้ดูเลย!',
      titleBigImage: 'เจอแฟ้มผลงานต้นฉบับสุดเจ๋ง แชร์ให้ดูเลย!',
      titlePdf: 'แฟ้มผลงาน PDF: {title}',
      titleLinkCard: 'แฟ้มผลงานเว็บ: {title}',
      titleOpenMaic: '{title}',
      titleArtBook: 'นิทาน: {title}',
      titleAudio: 'เจอเพลงที่ไพเราะมาก แชร์ให้ฟังเลย!',
      titleText: 'เจอข้อความแนวคิดดีมาก แชร์ให้อ่านเลย!',
      titleGame: 'เกมใหม่ "{title}" เปิดตัวแล้ว มาดูกัน!',
      titleModel3d: 'เจอโมเดล 3D สร้างสรรค์มาก แชร์ให้ดูเลย!',
      titleDefault: 'เจอคอลเลกชันผลงานสุดเจ๋ง แชร์ให้ดูเลย!',
      descVideo: 'วิดีโอต้นฉบับเต็มไปด้วยความคิดสร้างสรรค์{suffix}',
      descImage: 'รูปภาพต้นฉบับสร้างสรรค์มาก มาดูกัน!',
      descBigImage: 'จากแรงบันดาลใจสู่การสร้างสรรค์ — สำรวจเส้นทางการทำงานทั้งหมด',
      descAudio: 'ฟังเพลงต้นฉบับชิ้นใหม่～{suffix}',
      descGame: 'เกมต้นฉบับจากจินตนาการ — คุณจะเสียใจถ้าไม่ลอง!',
      descOpenMaic: 'ฉันสร้างคำอธิบายภาพใน MiaoBi มาดูกันเลย!',
      descArtBook: 'นิทานภาพต้นฉบับที่น่าประทับใจ มาอ่านกัน！',
      descTextEmpty: 'แชร์เนื้อหาต้นฉบับ มาอ่านกัน!',
      descDefault: 'คอลเลกชันผลงานจากนักเรียนหลายคน มาดูกัน!',
      descGeneric: 'ผลงานต้นฉบับสุดเจ๋ง มาดูกัน!',
    },
    duration: {
      seconds: '{s} วินาที',
      minSec: '{m} นาที {s} วินาที',
      hourMinSec: '{h} ชั่วโมง {m} นาที {s} วินาที',
      prefix: ' ระยะเวลา: {duration}',
    },
  },
  help: {
    title: 'ศูนย์ช่วยเหลือ',
    subtitle: 'ศูนย์ช่วยเหลือ MiaoBi — คู่มือการใช้งานและคำถามที่พบบ่อย',
    welcome: 'สวัสดี ยินดีต้อนรับ!',
    searchPlaceholder: 'ค้นหาคำถาม',
    guessAsk: 'คุณอาจสงสัยว่า',
    relatedCount: 'พบ {count} รายการที่เกี่ยวข้อง',
    noResult: 'ไม่พบคำถามที่เกี่ยวข้อง',
    myTickets: 'คำถามของฉัน',
    myTicketsHint: 'ดูประวัติคำถามและการตอบกลับอย่างเป็นทางการ',
    askQuestion: 'ถามคำถาม',
    detail: { title: 'รายละเอียดคำถาม' },
    list: { title: 'รายการคำถาม' },
    ask: {
      title: 'ส่งคำถาม',
      problemType: 'ประเภทคำถาม',
      problemTypePlaceholder: 'เลือกประเภทคำถาม',
      problemTypeRequired: 'กรุณาเลือกประเภทคำถาม',
      content: 'รายละเอียดคำถาม',
      contentPlaceholder: 'กรุณาระบุหน้า ขั้นตอนที่ทำ และสิ่งที่เกิดขึ้นให้ชัดเจน',
      contentRequired: 'กรุณากรอกรายละเอียดคำถาม',
      attachments: 'อัปโหลดรูปภาพและวิดีโอ',
      attachmentsTip: 'รองรับ JPG, PNG, MP4 เป็นต้น สูงสุด 6 ไฟล์',
      attachmentsUnavailable: 'ยังไม่มี API สำหรับอัปโหลดไฟล์แนบ',
      upload: 'เพิ่มไฟล์แนบ',
      uploading: 'กำลังอัปโหลด',
      uploadFailed: 'อัปโหลดไฟล์แนบไม่สำเร็จ กรุณาลองใหม่',
      uploadLimit: 'อัปโหลดได้สูงสุด 6 ไฟล์',
      uploadFormat: 'รองรับเฉพาะไฟล์รูปภาพและวิดีโอ',
      uploadSize: 'ไฟล์แนบแต่ละไฟล์ต้องไม่เกิน 50 MB',
      removeAttachment: 'ลบไฟล์แนบ',
      contactInfo: 'ข้อมูลติดต่อ (ไม่บังคับ)',
      contactPlaceholder: 'เบอร์โทรหรือ WeChat เพื่อให้เราตอบกลับได้',
      cancel: 'ยกเลิก',
      submit: 'ส่ง',
      submitting: 'กำลังส่ง…',
      submitSuccess: 'ส่งสำเร็จ',
      submitFailed: 'ส่งไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
      typeLoadFailed: 'โหลดประเภทคำถามไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
    },
    tickets: {
      title: 'คำถามของฉัน',
      empty: 'ยังไม่มีคำถาม',
      reply: 'การตอบกลับอย่างเป็นทางการ',
      ask: 'ถามคำถาม',
      loadFailed: 'โหลดคำถามไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
      status: {
        pending: 'รอดำเนินการ',
        processing: 'กำลังดำเนินการ',
        completed: 'ตอบกลับแล้ว',
        closed: 'ปิดแล้ว',
      },
    },
  },
  detail: {
    authorLabel: 'ผู้สร้าง: ',
    noTextContent: 'ไม่มีเนื้อหา',
    unknownCannotDisplay: 'ไม่สามารถแสดงผลงานนี้ได้',
    messageIdLabel: 'รหัสข้อความ: ',
    unknownRetryHint: 'กรุณาลองใหม่ภายหลังหรือรอเซิร์ฟเวอร์ดำเนินการ',
    unsupportedType: 'ประเภทผลงานที่ไม่รองรับ',
    typeLabel: 'ประเภท: ',
    pageTitleFallback: 'รายละเอียดผลงาน',
    downloadFileNameFallback: 'ผลงาน',
  },
  workList: {
    loading: 'กำลังโหลด…',
    empty: 'ไม่มีผลงาน',
    pageTitleDefault: 'รายการผลงาน',
    multiShareTitle: 'เจอคอลเลกชันผลงานสุดเจ๋ง แชร์ให้ดูเลย!',
    multiShareDesc: 'คอลเลกชันผลงานจากนักเรียนหลายคน มาดูกัน!',
    authorFallback: 'นักเรียน',
    unknownWorkTitle: 'ผลงานที่รอดำเนินการ',
    unknownWorkText: 'รายละเอียดรอเซิร์ฟเวอร์ดำเนินการ',
    errorMissingCode: 'ไม่พบรหัสผลงาน (code)',
    errorLoadFailed: 'โหลดล้มเหลว กรุณาลองใหม่',
    downloadFileNameFallback: 'ผลงาน',
  },
  download: {
    pageHeader: 'ดาวน์โหลดผลงาน {courseName}',
    studentUnit: ' คน',
    worksUnit: ' ชิ้น',
    downloadButton: 'ดาวน์โหลดผลงาน',
    progressTitle: 'ความคืบหน้าการดาวน์โหลด',
    completeTitle: 'ดาวน์โหลดสำเร็จ',
    completeTip: 'ดาวน์โหลดสำเร็จ {success}/{total} ไฟล์',
    typeVideo: 'วิดีโอ',
    typeImage: 'รูปภาพ',
    typePortfolio: 'แฟ้มผลงาน',
    typeEncyclopedia: 'สารานุกรม',
    typePictureBook: 'หนังสือภาพ',
    typeMusic: 'เพลง',
    typePortfolioPdf: 'แฟ้มผลงาน-PDF',
    typePortfolioWeb: 'แฟ้มผลงาน-เว็บ',
    typeGame: 'เกม',
    typeAiBook: 'หนังสือภาพ AI',
    typeOpenMaic: 'คำอธิบายภาพ',
    typeVectorImage: 'ภาพเวกเตอร์',
    typeImage2dTo3d: '2D เป็น 3D',
    typeUnknown: 'ไม่ทราบ',
    fileTypeModel: 'โมเดล',
    fileTypePreview: 'ภาพตัวอย่าง',
  },
  pdfPortfolio: {
    loading: 'กำลังโหลด...',
    loadError: 'โหลด PDF ล้มเหลว กรุณาลองใหม่',
    downloadButton: 'ดาวน์โหลด PDF',
    pageTitleFallback: 'แฟ้มผลงาน PDF',
    shareTitleFallback: 'แฟ้มผลงาน PDF',
    shareDesc: 'ผลงานต้นฉบับสุดเจ๋ง มาดูกัน!',
  },
  musicIsolate: {
    separating: 'กำลังแยกแทร็ก…',
    originalTrack: 'ต้นฉบับ',
    separationResult: 'ผลการแยกแทร็ก',
    startSeparation: 'เริ่มแยกแทร็ก',
    restartSeparation: 'แยกแทร็กใหม่',
  },
  modelViewer3d: {
    back: 'กลับ',
    loading: 'กำลังโหลดโมเดล…',
    loadError: 'โหลดโมเดลล้มเหลว กรุณาตรวจสอบลิงก์หรือเครือข่าย',
    pageTitleFallback: 'โมเดล 3D',
    shareDesc: 'ผลงานต้นฉบับสุดเจ๋ง มาดูกัน!',
  },
  pictureBook: {
    pageTitleFallback: 'หนังสือภาพ',
    titleSuffixPortfolio: 'แฟ้มผลงานเว็บ',
    titleSuffixBook: 'นิทานภาพ',
    shareDescPortfolio: 'ผลงานต้นฉบับสุดเจ๋ง มาดูกัน!',
    shareDescBook: 'นิทานภาพต้นฉบับที่น่าประทับใจ มาอ่านกัน!',
    portfolioWorkName: 'ผลงาน {n}',
    pageName: 'หน้า {n}',
  },
  lessonInfo: {
    titleArt: 'หลักสูตร AI ศิลปะทั่วไป',
    titleMagic: 'หลักสูตรวาดภาพมหัศจรรย์ AI',
    titleIp: 'หลักสูตร Super IP ด้วย AI',
    titleCourse: 'หลักสูตรสร้างสรรค์ AI',
    titleDesign: 'หลักสูตรออกแบบศิลปะ AI',
    titleArtDesign: 'ชั้นเรียนศิลปะ AI',
    titleAiSteam: 'หลักสูตร AI STEAM',
    titleFallback: 'รายละเอียดหลักสูตร',
  },
  home: {
    title: 'หน้าหลัก',
  },
};
